var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0001 28C22.134 28 19 24.866 19 20.9999C19 17.1339 22.134 13.9999 26.0001 13.9999C29.8661 13.9999 33.0001 17.1339 33.0001 20.9999C33.0001 24.866 29.8661 28 26.0001 28Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 4.00018C17.1634 4.00018 10 11.1636 10 20.0002C10 30.8002 24.1 43.0002 24.7 43.5202C25.4484 44.1604 26.5516 44.1604 27.3 43.5202C28 43.0002 42 30.8002 42 20.0002C42 11.1636 34.8366 4.00018 26 4.00018ZM26 41.9999C21.03 37.3992 12 27.4849 12 19.8018C12 12.1792 18.268 5.99988 26 5.99988C33.732 5.99988 40 12.1792 40 19.8018C40 27.4849 30.97 37.4222 26 41.9999Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4.00015C15.1634 4.00015 8 11.1636 8 20.0002C8 30.8002 22.1 43.0002 22.7 43.5202C23.4484 44.1603 24.5516 44.1603 25.3 43.5202C26 43.0002 40 30.8002 40 20.0002C40 11.1636 32.8366 4.00015 24 4.00015ZM24 41.9998C19.03 37.3992 10 27.4848 10 19.8018C10 12.1792 16.268 5.99984 24 5.99984C31.732 5.99984 38 12.1792 38 19.8018C38 27.4848 28.97 37.4222 24 41.9998ZM24 12C19.5817 12 16 15.5817 16 20C16 24.4182 19.5817 28 24 28C28.4183 28 32 24.4182 32 20C32 17.8782 31.1572 15.8434 29.6569 14.3431C28.1566 12.8428 26.1218 12 24 12ZM24 25.9998C20.6863 25.9998 18 23.3135 18 19.9998C18 16.6861 20.6863 13.9998 24 13.9998C27.3137 13.9998 30 16.6861 30 19.9998C30 23.3135 27.3137 25.9998 24 25.9998Z",
    fill: "#011E29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.68fec35cdbe930ea4e268435ac221eab.svg";
export { ForwardRef as ReactComponent };